import clsx from 'clsx';
import { H3, H4 } from 'components/UI/H/styled';
import React from 'react';

import s from './Form.module.less';

type DivProps = React.HTMLAttributes<HTMLDivElement>;
type HeadingProps = React.HTMLAttributes<HTMLHeadingElement>;
type HrProps = React.HTMLAttributes<HTMLHRElement>;

export const FormStyledFields: React.FC<DivProps> = ({ className, ...rest }) => (
  <div className={clsx(s.formStyledFields, className)} {...rest} />
);

export const FormWrapper: React.FC<DivProps> = ({ className, ...rest }) => (
  <div className={clsx(s.formWrapper, className)} {...rest} />
);

export const FormStyled: React.FC<DivProps> = ({ className, ...rest }) => (
  <div className={clsx(s.formStyled, className)} {...rest} />
);

export const Label: React.FC<HeadingProps> = ({ className, ...rest }) => (
  <H3 className={clsx(s.label, className)} {...rest} />
);

export const FormGroupLabel: React.FC<HeadingProps> = ({ className, ...rest }) => (
  <H4 className={clsx(s.formGroupLabel, className)} {...rest} />
);

export const FormGroupHR: React.FC<HrProps> = ({ className, ...rest }) => (
  <hr className={clsx(s.formGroupHr, className)} {...rest} />
);

export const FormItemBlock: React.FC<DivProps> = ({ className, ...rest }) => (
  <div className={clsx(s.formItemBlock, className)} {...rest} />
);
